/* This file is auto-generated. Do not edit it directly. */

/// <reference types="vite-plugin-svgr/client" />
import { withIconWrapper } from '../withIconWrapper';

import { default as Add } from '../../assets/Add.svg?react';
export const AddIcon = withIconWrapper(Add);

import { default as AddCircle } from '../../assets/AddCircle.svg?react';
export const AddCircleIcon = withIconWrapper(AddCircle);

import { default as AddOwner } from '../../assets/AddOwner.svg?react';
export const AddOwnerIcon = withIconWrapper(AddOwner);

import { default as AddUser } from '../../assets/AddUser.svg?react';
export const AddUserIcon = withIconWrapper(AddUser);

import { default as AiPrise } from '../../assets/AiPrise.svg?react';
export const AiPriseIcon = withIconWrapper(AiPrise);

import { default as InsuranceConnection } from '../../assets/Insurance.svg?react';
export const InsuranceConnectionIcon = withIconWrapper(InsuranceConnection);

import { default as Airwallex } from '../../assets/Airwallex.svg?react';
export const AirwallexIcon = withIconWrapper(Airwallex);

import { default as AirwallexKycOnboarding } from '../../assets/AirwallexKycOnboarding.svg?react';
export const AirwallexKycOnboardingIcon = withIconWrapper(AirwallexKycOnboarding);

import { default as AISign } from '../../assets/AISign.svg?react';
export const AISignIcon = withIconWrapper(AISign);

import { default as Allianz } from '../../assets/Allianz.svg?react';
export const AllianzIcon = withIconWrapper(Allianz);

import { default as Amex } from '../../assets/Amex.svg?react';
export const AmexIcon = withIconWrapper(Amex);

import { default as ArrowDown } from '../../assets/ArrowDown.svg?react';
export const ArrowDownIcon = withIconWrapper(ArrowDown);

import { default as ArrowLeft } from '../../assets/ArrowLeft.svg?react';
export const ArrowLeftIcon = withIconWrapper(ArrowLeft);

import { default as ArrowRight } from '../../assets/ArrowRight.svg?react';
export const ArrowRightIcon = withIconWrapper(ArrowRight);

import { default as ArrowUp } from '../../assets/ArrowUp.svg?react';
export const ArrowUpIcon = withIconWrapper(ArrowUp);

import { default as Atradius } from '../../assets/Atradius.svg?react';
export const AtradiusIcon = withIconWrapper(Atradius);

import { default as Attachment } from '../../assets/Attachment.svg?react';
export const AttachmentIcon = withIconWrapper(Attachment);

import { default as Attachments } from '../../assets/Attachments.svg?react';
export const AttachmentsIcon = withIconWrapper(Attachments);

import { default as Audits } from '../../assets/Audits.svg?react';
export const AuditsIcon = withIconWrapper(Audits);

import { default as Bank } from '../../assets/Bank.svg?react';
export const BankIcon = withIconWrapper(Bank);

import { default as BankWork } from '../../assets/BankWork.svg?react';
export const BankWorkIcon = withIconWrapper(BankWork);

import { default as Block } from '../../assets/Block.svg?react';
export const BlockIcon = withIconWrapper(Block);

import { default as LockOpen } from '../../assets/lockOpen.svg?react';
export const LockOpenIcon = withIconWrapper(LockOpen);

import { default as Blur } from '../../assets/Blur.svg?react';
export const BlurIcon = withIconWrapper(Blur);

import { default as RiskScoreBlur } from '../../assets/RiskBlur.svg?react';
export const RiskScoreBlurIcon = withIconWrapper(RiskScoreBlur);

import { default as ComplianceBlur } from '../../assets/ComplianceBlur.svg?react';
export const ComplianceBlurIcon = withIconWrapper(ComplianceBlur);

import { default as Crown } from '../../assets/Crown.svg?react';
export const CrownIcon = withIconWrapper(Crown);

import { default as AdvancedReport } from '../../assets/AdvancedReport.svg?react';
export const AdvancedReportIcon = withIconWrapper(AdvancedReport);

import { default as BlurKYC } from '../../assets/BlurKYC.svg?react';
export const BlurKYCIcon = withIconWrapper(BlurKYC);

import { default as Briefcase } from '../../assets/Briefcase.svg?react';
export const BriefcaseIcon = withIconWrapper(Briefcase);

import { default as Bullet } from '../../assets/Bullet.svg?react';
export const BulletIcon = withIconWrapper(Bullet);

import { default as BusinessDetails } from '../../assets/BusinessDetails.svg?react';
export const BusinessDetailsIcon = withIconWrapper(BusinessDetails);

import { default as BusinessVerification } from '../../assets/BusinessVerification.svg?react';
export const BusinessVerificationIcon = withIconWrapper(BusinessVerification);

import { default as Buyer } from '../../assets/Buyer.svg?react';
export const BuyerIcon = withIconWrapper(Buyer);

import { default as BuyerFunds } from '../../assets/BuyerFunds.svg?react';
export const BuyerFundsIcon = withIconWrapper(BuyerFunds);

import { default as CalendarCheck } from '../../assets/CalendarCheck.svg?react';
export const CalendarCheckIcon = withIconWrapper(CalendarCheck);

import { default as CalendarMonth } from '../../assets/CalendarMonth.svg?react';
export const CalendarMonthIcon = withIconWrapper(CalendarMonth);

import { default as Cancel } from '../../assets/Cancel.svg?react';
export const CancelIcon = withIconWrapper(Cancel);

import { default as Charge } from '../../assets/Charge.svg?react';
export const ChargeIcon = withIconWrapper(Charge);

import { default as Check } from '../../assets/Check.svg?react';
export const CheckIcon = withIconWrapper(Check);

import { default as CheckCircle } from '../../assets/CheckCircle.svg?react';
export const CheckCircleIcon = withIconWrapper(CheckCircle);

import { default as Checkouts } from '../../assets/Checkouts.svg?react';
export const CheckoutsIcon = withIconWrapper(Checkouts);

import { default as CheckSquare } from '../../assets/CheckSquare.svg?react';
export const CheckSquareIcon = withIconWrapper(CheckSquare);

import { default as ChevronDown } from '../../assets/ChevronDown.svg?react';
export const ChevronDownIcon = withIconWrapper(ChevronDown);

import { default as ChevronLeft } from '../../assets/ChevronLeft.svg?react';
export const ChevronLeftIcon = withIconWrapper(ChevronLeft);

import { default as ChevronRight } from '../../assets/ChevronRight.svg?react';
export const ChevronRightIcon = withIconWrapper(ChevronRight);

import { default as ChevronUp } from '../../assets/ChevronUp.svg?react';
export const ChevronUpIcon = withIconWrapper(ChevronUp);

import { default as Circle } from '../../assets/Circle.svg?react';
export const CircleIcon = withIconWrapper(Circle);

import { default as Clock } from '../../assets/Clock.svg?react';
export const ClockIcon = withIconWrapper(Clock);

import { default as Close } from '../../assets/Close.svg?react';
export const CloseIcon = withIconWrapper(Close);

import { default as Codat } from '../../assets/Codat.svg?react';
export const CodatIcon = withIconWrapper(Codat);

import { default as Column } from '../../assets/Column.svg?react';
export const ColumnIcon = withIconWrapper(Column);

import { default as ComplyAdvantage } from '../../assets/ComplyAdvantage.svg?react';
export const ComplyAdvantageIcon = withIconWrapper(ComplyAdvantage);

import { default as Copy } from '../../assets/Copy.svg?react';
export const CopyIcon = withIconWrapper(Copy);

import { default as Cover } from '../../assets/Cover.svg?react';
export const CoverIcon = withIconWrapper(Cover);

import { default as CreditCard } from '../../assets/CreditCard.svg?react';
export const CreditCardIcon = withIconWrapper(CreditCard);

import { default as CreditLine } from '../../assets/CreditLine.svg?react';
export const CreditLineIcon = withIconWrapper(CreditLine);

import { default as CreditReviewBankConnection } from '../../assets/CreditReviewBankConnection.svg?react';
export const CreditReviewBankConnectionIcon = withIconWrapper(CreditReviewBankConnection);

import { default as CreditReviewDocuments } from '../../assets/CreditReviewDocuments.svg?react';
export const CreditReviewDocumentsIcon = withIconWrapper(CreditReviewDocuments);

import { default as creditReviewInProgress } from '../../assets/creditReviewInProgress.svg?react';
export const CreditReviewInProgressIcon = withIconWrapper(creditReviewInProgress);

import { default as CurrencyConversion } from '../../assets/CurrencyConversion.svg?react';
export const CurrencyConversionIcon = withIconWrapper(CurrencyConversion);

import { default as Customizations } from '../../assets/Customizations.svg?react';
export const CustomizationsIcon = withIconWrapper(Customizations);

import { default as Delete } from '../../assets/Delete.svg?react';
export const DeleteIcon = withIconWrapper(Delete);

import { default as Discover } from '../../assets/Discover.svg?react';
export const DiscoverIcon = withIconWrapper(Discover);

import { default as DollarBill } from '../../assets/DollarBill.svg?react';
export const DollarBillIcon = withIconWrapper(DollarBill);

import { default as Download } from '../../assets/Download.svg?react';
export const DownloadIcon = withIconWrapper(Download);

import { default as DragIndicator } from '../../assets/DragIndicator.svg?react';
export const DragIndicatorIcon = withIconWrapper(DragIndicator);

import { default as Edit } from '../../assets/Edit.svg?react';
export const EditIcon = withIconWrapper(Edit);

import { default as Email } from '../../assets/Email.svg?react';
export const EmailIcon = withIconWrapper(Email);

import { default as Error } from '../../assets/Error.svg?react';
export const ErrorIcon = withIconWrapper(Error);

import { default as Experian } from '../../assets/Experian.svg?react';
export const ExperianIcon = withIconWrapper(Experian);

import { default as ExternalEntities } from '../../assets/ExternalEntities.svg?react';
export const ExternalEntitiesIcon = withIconWrapper(ExternalEntities);

import { default as FactoringAgreement } from '../../assets/FactoringAgreement.svg?react';
export const FactoringAgreementIcon = withIconWrapper(FactoringAgreement);

import { default as Files } from '../../assets/Files.svg?react';
export const FilesIcon = withIconWrapper(Files);

import { default as FileSignature } from '../../assets/FileSignature.svg?react';
export const FileSignatureIcon = withIconWrapper(FileSignature);

import { default as Filter } from '../../assets/Filter.svg?react';
export const FilterIcon = withIconWrapper(Filter);

import { default as FinancialConnections } from '../../assets/FinancialConnections.svg?react';
export const FinancialConnectionsIcon = withIconWrapper(FinancialConnections);

import { default as Fingerprint } from '../../assets/Fingerprint.svg?react';
export const FingerprintIcon = withIconWrapper(Fingerprint);

import { default as Flash } from '../../assets/Flash.svg?react';
export const FlashIcon = withIconWrapper(Flash);

import { default as Funds } from '../../assets/Funds.svg?react';
export const FundsIcon = withIconWrapper(Funds);

import { default as Gauge } from '../../assets/Gauge.svg?react';
export const GaugeIcon = withIconWrapper(Gauge);

import { default as GoCardless } from '../../assets/GoCardless.svg?react';
export const GoCardlessIcon = withIconWrapper(GoCardless);

import { default as Help } from '../../assets/Help.svg?react';
export const HelpIcon = withIconWrapper(Help);

import { default as Heron } from '../../assets/Heron.svg?react';
export const HeronIcon = withIconWrapper(Heron);

import { default as Identity } from '../../assets/Identity.svg?react';
export const IdentityIcon = withIconWrapper(Identity);

import { default as IdentityVerification } from '../../assets/IdentityVerification.svg?react';
export const IdentityVerificationIcon = withIconWrapper(IdentityVerification);

import { default as ImageSearch } from '../../assets/ImageSearch.svg?react';
export const ImageSearchIcon = withIconWrapper(ImageSearch);

import { default as Inbox } from '../../assets/Inbox.svg?react';
export const InboxIcon = withIconWrapper(Inbox);

import { default as Info } from '../../assets/Info.svg?react';
export const InfoIcon = withIconWrapper(Info);

import { default as Intents } from '../../assets/Intents.svg?react';
export const IntentsIcon = withIconWrapper(Intents);

import { default as Invites } from '../../assets/Invites.svg?react';
export const InvitesIcon = withIconWrapper(Invites);

import { default as Invoice } from '../../assets/Invoice.svg?react';
export const InvoiceIcon = withIconWrapper(Invoice);

import { default as InvoiceSearch } from '../../assets/InvoiceSearch.svg?react';
export const InvoiceSearchIcon = withIconWrapper(InvoiceSearch);

import { default as Language } from '../../assets/Language.svg?react';
export const LanguageIcon = withIconWrapper(Language);

import { default as Leads } from '../../assets/Leads.svg?react';
export const LeadsIcon = withIconWrapper(Leads);

import { default as LedgerEntries } from '../../assets/LedgerEntries.svg?react';
export const LedgerEntriesIcon = withIconWrapper(LedgerEntries);

import { default as Link } from '../../assets/Link.svg?react';
export const LinkIcon = withIconWrapper(Link);

import { default as Log } from '../../assets/Log.svg?react';
export const LogIcon = withIconWrapper(Log);

import { default as Login } from '../../assets/Login.svg?react';
export const LoginIcon = withIconWrapper(Login);

import { default as Logout } from '../../assets/Logout.svg?react';
export const LogoutIcon = withIconWrapper(Logout);

import { default as MapPin } from '../../assets/MapPin.svg?react';
export const MapPinIcon = withIconWrapper(MapPin);

import { default as Mastercard } from '../../assets/Mastercard.svg?react';
export const MastercardIcon = withIconWrapper(Mastercard);

import { default as Menu } from '../../assets/Menu.svg?react';
export const MenuIcon = withIconWrapper(Menu);

import { default as Minus } from '../../assets/Minus.svg?react';
export const MinusIcon = withIconWrapper(Minus);

import { default as MinusCircle } from '../../assets/MinusCircle.svg?react';
export const MinusCircleIcon = withIconWrapper(MinusCircle);

import { default as MinusSquare } from '../../assets/MinusSquare.svg?react';
export const MinusSquareIcon = withIconWrapper(MinusSquare);

import { default as Money } from '../../assets/Money.svg?react';
export const MoneyIcon = withIconWrapper(Money);

import { default as MoneyOff } from '../../assets/MoneyOff.svg?react';
export const MoneyOffIcon = withIconWrapper(MoneyOff);

import { default as MoreVert } from '../../assets/MoreVert.svg?react';
export const MoreVertIcon = withIconWrapper(MoreVert);

import { default as MoveFunds } from '../../assets/MoveFunds.svg?react';
export const MoveFundsIcon = withIconWrapper(MoveFunds);

import { default as Noble } from '../../assets/Noble.svg?react';
export const NobleIcon = withIconWrapper(Noble);

import { default as OCR } from '../../assets/OCR.svg?react';
export const OCRIcon = withIconWrapper(OCR);

import { default as OpenNew } from '../../assets/OpenNew.svg?react';
export const OpenNewIcon = withIconWrapper(OpenNew);

import { default as Orders } from '../../assets/Orders.svg?react';
export const OrdersIcon = withIconWrapper(Orders);

import { default as Organizations } from '../../assets/Organizations.svg?react';
export const OrganizationsIcon = withIconWrapper(Organizations);

import { default as Overview } from '../../assets/Overview.svg?react';
export const OverviewIcon = withIconWrapper(Overview);

import { default as PaymentMethods } from '../../assets/PaymentMethods.svg?react';
export const PaymentMethodsIcon = withIconWrapper(PaymentMethods);

import { default as Payout } from '../../assets/Payout.svg?react';
export const PayoutIcon = withIconWrapper(Payout);

import { default as PdfFile } from '../../assets/PdfFile.svg?react';
export const PdfFileIcon = withIconWrapper(PdfFile);

import { default as PersonalGuarantee } from '../../assets/PersonalGuarantee.svg?react';
export const PersonalGuaranteeIcon = withIconWrapper(PersonalGuarantee);

import { default as Placeholder } from '../../assets/Placeholder.svg?react';
export const PlaceholderIcon = withIconWrapper(Placeholder);

import { default as Reconciliation } from '../../assets/Reconciliation.svg?react';
export const ReconciliationIcon = withIconWrapper(Reconciliation);

import { default as Referrals } from '../../assets/Referrals.svg?react';
export const ReferralsIcon = withIconWrapper(Referrals);

import { default as Refresh } from '../../assets/Refresh.svg?react';
export const RefreshIcon = withIconWrapper(Refresh);

import { default as Refunds } from '../../assets/Refunds.svg?react';
export const RefundsIcon = withIconWrapper(Refunds);

import { default as Replay } from '../../assets/Replay.svg?react';
export const ReplayIcon = withIconWrapper(Replay);

import { default as Reports } from '../../assets/Reports.svg?react';
export const ReportsIcon = withIconWrapper(Reports);

import { default as Search } from '../../assets/Search.svg?react';
export const SearchIcon = withIconWrapper(Search);

import { default as SendEmail } from '../../assets/SendEmail.svg?react';
export const SendEmailIcon = withIconWrapper(SendEmail);

import { default as Settings } from '../../assets/Settings.svg?react';
export const SettingsIcon = withIconWrapper(Settings);

import { default as Shipping } from '../../assets/Shipping.svg?react';
export const ShippingIcon = withIconWrapper(Shipping);

import { default as Split } from '../../assets/Split.svg?react';
export const SplitIcon = withIconWrapper(Split);

import { default as Square } from '../../assets/Square.svg?react';
export const SquareIcon = withIconWrapper(Square);

import { default as Stripe } from '../../assets/Stripe.svg?react';
export const StripeIcon = withIconWrapper(Stripe);

import { default as Subdirectory } from '../../assets/Subdirectory.svg?react';
export const SubdirectoryIcon = withIconWrapper(Subdirectory);

import { default as Supplier } from '../../assets/Supplier.svg?react';
export const SupplierIcon = withIconWrapper(Supplier);

import { default as Swap } from '../../assets/Swap.svg?react';
export const SwapIcon = withIconWrapper(Swap);

import { default as Sync } from '../../assets/Sync.svg?react';
export const SyncIcon = withIconWrapper(Sync);

import { default as Telephone } from '../../assets/Telephone.svg?react';
export const TelephoneIcon = withIconWrapper(Telephone);

import { default as Tenants } from '../../assets/Tenants.svg?react';
export const TenantsIcon = withIconWrapper(Tenants);

import { default as Transactions } from '../../assets/Transactions.svg?react';
export const TransactionsIcon = withIconWrapper(Transactions);

import { default as Underwritings } from '../../assets/Underwritings.svg?react';
export const UnderwritingsIcon = withIconWrapper(Underwritings);

import { default as Undo } from '../../assets/Undo.svg?react';
export const UndoIcon = withIconWrapper(Undo);

import { default as Unfold } from '../../assets/Unfold.svg?react';
export const UnfoldIcon = withIconWrapper(Unfold);

import { default as UploadFile } from '../../assets/UploadFile.svg?react';
export const UploadFileIcon = withIconWrapper(UploadFile);

import { default as User } from '../../assets/User.svg?react';
export const UserIcon = withIconWrapper(User);

import { default as UserConsents } from '../../assets/UserConsents.svg?react';
export const UserConsentsIcon = withIconWrapper(UserConsents);

import { default as Verified } from '../../assets/Verified.svg?react';
export const VerifiedIcon = withIconWrapper(Verified);

import { default as Visa } from '../../assets/Visa.svg?react';
export const VisaIcon = withIconWrapper(Visa);

import { default as VisibilityOff } from '../../assets/VisibilityOff.svg?react';
export const VisibilityOffIcon = withIconWrapper(VisibilityOff);

import { default as VisibilityOn } from '../../assets/VisibilityOn.svg?react';
export const VisibilityOnIcon = withIconWrapper(VisibilityOn);

import { default as Warning } from '../../assets/Warning.svg?react';
export const WarningIcon = withIconWrapper(Warning);

import { default as Webhook } from '../../assets/Webhook.svg?react';
export const WebhookIcon = withIconWrapper(Webhook);

import { default as Wire } from '../../assets/Wire.svg?react';
export const WireIcon = withIconWrapper(Wire);

import { default as Wise } from '../../assets/Wise.svg?react';
export const WiseIcon = withIconWrapper(Wise);

import { default as Wiserfunding } from '../../assets/Wiserfunding.svg?react';
export const WiserfundingIcon = withIconWrapper(Wiserfunding);

import { default as Withdraw } from '../../assets/Withdraw.svg?react';
export const WithdrawIcon = withIconWrapper(Withdraw);
